import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { __ } from '../../../../helpers/translations';
import SetEmailHeaderModal from '../modals/SetEmailHeaderModal';

function SetEmailHeaderButton({ survey, onChanged, disabled }) {
  const [showSetEmailHeaderModal, setShowSetEmailHeaderModal] = useState(false);

  return (
    <>
      <Button
        title={__('G298')}
        size="md"
        variant="light"
        onClick={() => setShowSetEmailHeaderModal(true)}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faEnvelopeOpenText} />
      </Button>
      {showSetEmailHeaderModal && (
      <SetEmailHeaderModal
        emailHeader={survey.emailHeader || ''}
        onChanged={() => {
          setShowSetEmailHeaderModal(false);
          onChanged();
        }}
        onCancel={() => setShowSetEmailHeaderModal(false)}
        surveyId={survey.surveyId}
      />
      )}
    </>
  );
}

SetEmailHeaderButton.propTypes = {
  survey: PropTypes.shape({
    surveyId: PropTypes.string.isRequired,
    emailHeader: PropTypes.string,
  }),
  onChanged: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SetEmailHeaderButton;
